import { FC } from "react";

import { useIsMobile } from "@ryde/shared";

import { PageHeaderDesktop } from "./page-header.desktop";
import { PageHeaderMobile } from "./page-header.mobile";
import { IHeaderProps } from "./page-header.models";

export const PageHeader: FC<IHeaderProps> = ({ children, ...props }) => {
  const { mainTitle, topWidgetComponent, CustomMobileHeaderComponent } = props;
  const { isMobile } = useIsMobile();

  return (
    <>
      {!isMobile && (
        <PageHeaderDesktop {...props}>{children}</PageHeaderDesktop>
      )}
      {isMobile && !CustomMobileHeaderComponent && (
        <PageHeaderMobile
          mainTitle={mainTitle}
          topWidgetComponent={topWidgetComponent}
          bottomWidgetComponent={props.bottomWidgetComponent}
          mobileStatLeftComponent={props.mobileStatLeftComponent}
        >
          {children}
        </PageHeaderMobile>
      )}
      {isMobile && CustomMobileHeaderComponent !== undefined && (
        <CustomMobileHeaderComponent
          mainTitle={mainTitle}
          topWidgetComponent={topWidgetComponent}
        >
          {children}
        </CustomMobileHeaderComponent>
      )}
    </>
  );
};
